import { render, staticRenderFns } from "./CoursewareDateBlock.vue?vue&type=template&id=3f297202&scoped=true&"
import script from "./CoursewareDateBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareDateBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareDateBlock.vue?vue&type=style&index=0&id=3f297202&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f297202",
  null
  
)

export default component.exports